import React from 'react';
import { Helmet } from 'react-helmet-async';
import ApplyTrial from '../components/SignUp/ApplyTrialPage';

function ApplyTrialPage() {
  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Apply for FREE TRIAL</title>
        <meta
          name="description"
          content="Dive Deeper with Millions of Data Points Using DISGENET Advanced."
        />
        <link rel="canonical" href="/free-trial-apply" />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/free-trial-apply" />
        <meta property="og:title" content="DISGENET: Apply for FREE TRIAL" />
        <meta
          property="og:description"
          content="Unlock millions of data points and enhance your research with DISGENET Advanced. Apply for a free trial today!"
        />
        <meta property="og:image" content="../public/static/images/LOGO_DISGENET.svg" />
      </Helmet>
      <ApplyTrial />
    </React.Fragment>
  );
}

export default ApplyTrialPage;
